import axiosInstance from '../api/axios';


// Function to get all students
export const getAllStudentRequests = async () => {
    try {
        const response = await axiosInstance.get('/studentrequests');
        return response.data;
    } catch (error) {
        console.error('Error fetching studentrequests:', error);
        throw error;
    }
};

export const getStudentRequestById = async (id) => {
    try {
        const response = await axiosInstance.get(`/getStudentRequestById?id=${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching students:', error);
        throw error;
    }
};